export { DMS_MODULE } from '../constants';
export { NAME } from '@/modules/kartoteka/partner/constants';


export enum MESSAGE_TYPE {
	SMS_EMAIL = 'smsAndEmail',
	SMS = 'sms',
	EMAIL = 'email'
}

export enum EMAIL_TYP_PZN {
	ZAKAZNIK = 29,
	VOZIDLO = 30,
	ROZPRACOVANA_ZAKAZKA = 34,
	ARCHIV_DILNA_DOKLAD = 27,
	WATCHLISTED_NOTIFICATION = 39,
	WATCHLISTED_APPROVAL_FOR_NEW_PARTS = 40,
	WATCHLISTED_APPROVAL_NOTIFICATION = 41
}
export enum SMS_TYP_PZN {
	ZAKAZNIK = 26,
	VOZIDLO = 27,
	ROZPRACOVANA_ZAKAZKA = 6,
	DEZEN_PNEU = 8,
}
